import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";

// Public Pages
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import MemberProfile from "./pages/MemberProfile";
import Wholesale from "./pages/Wholesale";
import WorkWithUs from "./pages/WorkWithUs";
import OurLocation from "./pages/OurLocation";
import OurCoffee from "./pages/OurCoffee";
import OurSpace from "./pages/OurSpace";
import OurStory from "./pages/OurStory";
import NotFound from "./pages/NotFound";

// Admin Pages
import Dashboard from './pages/admin/Dashboard';
import ProductIndex from "./pages/admin/products/Index";
import CreateProduct from "./pages/admin/products/Create";
import EditProduct from "./pages/admin/products/Edit";
import Scanner from './pages/admin/Scanner';
import UserIndex from './pages/admin/users/Index';
import PostIndex from './pages/admin/posts/Index';
import CreatePost from './pages/admin/posts/Create';
import EditPost from './pages/admin/posts/Edit';
import AdminNotFound from './pages/admin/AdminNotFound';
import Login from './pages/admin/Login';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin Routes - Protected */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="products" element={<ProductIndex />} />
              <Route path="products/create" element={<CreateProduct />} />
              <Route path="products/:id/edit" element={<EditProduct />} />

              <Route path="scanner" element={<Scanner />} />
              <Route path="users" element={<UserIndex />} />
              <Route path="posts" element={<PostIndex />} />
              <Route path="posts/create" element={<CreatePost />} />
              <Route path="posts/:id/edit" element={<EditPost />} />
            </Route>

            {/* 404 for unknown admin routes - outside AdminLayout */}
            <Route path="/admin/*" element={
              <ProtectedRoute>
                <AdminNotFound />
              </ProtectedRoute>
            } />

            {/* Admin Login */}
            <Route path="/login" element={<Login />} />

            {/* Public Routes */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/work-with-us" element={<WorkWithUs />} />
              <Route path="/our-location" element={<OurLocation />} />
              <Route path="/our-story" element={<OurStory />} />
              <Route path="/our-coffee" element={<OurCoffee />} />
              <Route path="/our-space" element={<OurSpace />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:id" element={<BlogDetail />} />
              <Route path="/member" element={<MemberProfile />} />
            </Route>

            {/* 404 Fallback for all other routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </ErrorBoundary>
  );
}

export default App;
